/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

export default {
	LICENSE_CHECK_ERROR: 240_001,
	LICENSE_CHECK_WARNING: 240_002,
	USER_DATA_GET_WARNING: 240_003,
	LOCAL_STORAGE_SUPPORT_WARNING: 240_004,
	GET_VOICEMAIL_URL_ERROR: 240_005,
	GET_USER_DATA_ERROR: 240_006,
	FORCE_CLOSE_ERROR: 240_007,
	UNDO_FORCE_CLOSE_ERROR: 240_008,
	FETCH_CLOSING_HOURS_ERROR: 240_009,
	SAVE_CLOSING_HOURS_ERROR: 240_010,
	SAVE_QUEUE_SETTINGS_ERROR: 240_011,
	FETCH_QUEUES_ERROR: 240_012,
	SAVE_CLOSED_MESSAGES_ERRORS: 240_013,
	GET_QUEUES_API_ERROR: 240_014,
	GET_QUEUE_API_ERROR: 240_015,
	UPDATE_CLOSED_DATA_API_ERROR: 240_016,
	GET_CLOSED_DATA_API_ERROR: 240_017,
	UPDATE_CLOSING_HOURS_API_ERROR: 240_018,
	GET_CLOSING_HOURS_API_ERROR: 240_019,
	UPDATE_HOLIDAYS_API_ERROR: 240_020,
	GET_HOLIDAYS_API_ERROR: 240_021,
	UPDATE_OVERWRITES_API_ERROR: 240_022,
	GET_OVERWRITES_API_ERROR: 240_023,
	ADD_PROMPT_LANGUAGE_ERROR: 240_024,
	DELETE_PROMPT_LANGUAGE_ERROR: 240_025,
	ADD_PROMPT_NAMESPACE_ERROR: 240_026,
	DELETE_PROMPT_NAMESPACE_ERROR: 240_027,
	GET_PROMPT_LANGUAGES_API_ERROR: 240_028,
	ADD_PROMPT_LANGUAGE_API_ERROR: 240_029,
	DELETE_PROMPT_LANGUAGE_API_ERROR: 240_030,
	GET_PROMPT_NAMESPACES_API_ERROR: 240_031,
	ADD_PROMPT_NAMESPACE_API_ERROR: 240_032,
	DELETE_PROMPT_NAMESPACE_API_ERROR: 240_033,
	GET_PROMPTS_API_ERROR: 240_034,
	ADD_PROMPT_API_ERROR: 240_035,
	UPDATE_PROMPT_API_ERROR: 240_036,
	DELETE_PROMPT_API_ERROR: 240_037,
	DELETE_PROMPTS_API_ERROR: 240_038,
	ADD_PROMPT_ERROR: 240_039,
	UPDATE_PROMPT_ERROR: 240_040,
	DELETE_PROMPT_ERROR: 240_041,
	UPLOAD_PROMPTS_API_ERROR: 240_042,
	LOAD_PROMPT_SETTINGS_ERROR: 240_043,
	UPLOAD_CSV_ERROR: 240_044,
	DELETE_WEBCHAT_CONFIG_ERROR: 240_045,
	GET_TERMINOLOGY_DATA_ERROR: 240_046,
	GET_CONTACT_FLOWS_API_ERROR: 240_047,
	UPDATE_WEBCHAT_CONFIG_API_ERROR: 240_048,
	GET_WEBCHAT_CONFIG_API_ERROR: 240_049,
	UPDATE_TERMINOLOGIES_API_ERROR: 240_050,
	GET_WEBCHAT_TERMINOLOGIES_API_ERROR: 240_051,
	UPDATE_CONFIG_API_ERROR: 240_052,
	GET_CONFIG_API_ERROR: 240_053,
	LICENSE_CHECK_API_ERROR: 240_054,
	READ_TERMINOLOGY_CSV_ERROR: 240_055,
	SAVE_TERMINOLOGY_DATA_ERROR: 240_056,
	DELETE_TERMINOLOGY_DATA_API_ERROR: 240_057,
	UPDATE_WEBCHAT_CONFIG_ERROR: 240_058,
	GET_CONNECTPROMPTS_API_ERROR: 240_082,
	SAVE_AGENT_CONSOLE_LAYOUT_SETTINGS_ERROR: 240_083,
	FETCH_AGENT_CONSOLE_LAYOUT_SETTINGS_ERROR: 240_084,
	CREATE_DISPOSITION_API_ERROR: 240_085,
	UPDATE_DISPOSITION_API_ERROR: 240_086,
	DELETE_DISPOSITION_API_ERROR: 240_087,
	GET_DISPOSITION_LIST_API_ERROR: 240_088,
	UPDATE_DISPOSITION_ERROR: 240_089,
	DELETE_DISPOSITION_ERROR: 240_090,
	GET_DISPOSITION_LIST_ERROR: 240_091,
	CREATE_DISPOSITION_ERROR: 240_092,
	GET_USER_LIST_API_ERROR: 240_093,
	UPDATE_USERS_ERROR: 240_094,
	GET_USER_BY_ID_ERROR: 240_095,
	CREATE_NEW_USERS_ERROR: 240_096,
	GET_CONFIG_VALUES_ERROR: 240_097,
	UPDATE_CONFIG_VALUES_ERROR: 240_098,
	CREATE_NEW_USERS_API_ERROR: 240_099,
	GET_USER_BY_ID_API_ERROR: 240_100,
	DELETE_USERS_ERROR: 240_101,
	GET_CALLMENOW_CONFIG_API_ERROR: 240_102,
	UPDATE_CALLMENOW_CONFIG_ERROR: 240_103,
	DELETE_CALLMENOW_CONFIG_ERROR: 240_104,
	GET_PHONE_NUMBERS_API_ERROR: 240_105,
	DELETE_EXT_CONTACTS_API_ERROR: 240_117,
	GET_EXT_CONTACTS_API_ERROR: 240_118,
	SAVE_EXTERNAL_CONTACTS_ERROR: 240_119,
	FETCH_EXTERNAL_CONTACTS_ERROR: 240_120,
	DELETE_EXTERNAL_CONTACTS_ERROR: 240_121,
	UPDATE_EXTERNAL_CONTACTS_ERROR: 240_122,
	UPDATE_EXT_CONTACTS_API_ERROR: 240_123,
	UPDATE_CANNED_RESPONSE_CATEGORY_API_ERROR: 240_125,
	DELETE_CANNED_RESPONSE_CATEGORY_API_ERROR: 240_126,
	GET_CANNED_RESPONSE_CATEGORIES_LIST_API_ERROR: 240_127,
	UPDATE_CANNED_RESPONSE_CATEGORY_ERROR: 240_128,
	DELETE_CANNED_RESPONSE_CATEGORY_ERROR: 240_129,
	GET_CANNED_RESPONSE_CATEGORIES_LIST_ERROR: 240_130,
	CONTACT_HISTORY_GET_ERROR: 240_131,
	ERROR_BOUNDARY: 240_132,
	METRICS_DISPLAY_GET_ERROR: 240_133,
	CONTACT_HISTORY_GET_API_ERROR: 240_134,
	CONNECT_LOOKUPS_GET_API_ERROR: 240_135,
	CONNECT_REPORTS_GET_API_ERROR: 240_136,
	CONNECT_REPORTS_LOOKUPS_GET_API_ERROR: 240_137,
	LOCALIZATION_MATCH_ERROR: 240_138,
	INIT_ERROR: 240_139,
	UNKNOWN_CONTACT_HISTORY_EVENT_WARNING: 240_140,
	SET_AGENT_OFFLINE_ERROR: 240_141,
	USER_OFFLINE_WARNING: 240_142,
	USER_LOGGED_OUT_WARNING: 240_143,
	SET_CONTACT_NOTES_API_ERROR: 240_144,
	GET_DISPOSITIONS_API_ERROR: 240_145,
	GET_CONTACT_ATTRIBUTES_ERROR: 240_146,
	UPDATE_CONTACT_ATTRIBUTES_ERROR: 240_147,
	REMOVE_AGENT_STATUSES_ERROR: 240_148,
	GET_AGENT_STATUSES_API_ERROR: 241_001,
	GET_AGENT_STATUS_ALERTS_API_ERROR: 241_002,
	UPDATE_AGENT_STATUS_ALERTS_API_ERROR: 241_003,
	CONTACT_SENTIMENT_ANALYSIS_RESULTS_GET_ERROR: 241_004,
	SAVE_HISTORICAL_REPORT_ERROR: 241_005,
	UPDATE_HISTORICAL_REPORT_ERROR: 241_006,
	GET_AGENTS_API_ERROR: 241007,
	UPDATE_AGENTS_API_ERROR: 241008,
	GET_GLOBAL_SETTINGS_API_ERROR: 241009,
	UPDATE_GLOBAL_SETTINGS_API_ERROR: 241010,
	SYNC_AGENTS_API_ERROR: 241011,
	GET_AGENT_BY_ID_ERROR: 241012,
	SAVE_METRICS_SETTINGS_ERROR: 241013,
	FETCH_METRICS_SETTINGS_ERROR: 241014,
	GET_DASHBOARD_URL_CONFIG: 241015,
	UPDATE_DASHBOARD_URL_CONFIG: 241016,
	GET_THIRD_PARTY_APPLICATIONS_ERROR: 241017,
	UPDATE_THIRD_PARTY_APPLICATIONS_ERROR: 241018,
	DELETE_THIRD_PARTY_APPLICATIONS_ERROR: 241019,
	GET_ASSOCIATED_LEX_BOTS_V2_API_ERROR: 241020,
	GET_LEX_BOT_V2_LIST_ERROR_API_ERROR: 241021,
	GET_LEX_BOT_V2_DETAILS_API_ERROR: 241022,
	GET_LEX_BOT_V2_LOCALES_API_ERROR: 241023,
	GET_LEX_BOT_V2_INTENTS_API_ERROR: 241024,
	GET_LEX_BOT_V2_ALIASES_API_ERROR: 241025,
	ASSOCIATE_LEX_BOT_V2_TO_CONNECT_API_ERROR: 241026,
	DISASSOCIATE_LEX_BOT_V2_FROM_CONNECT_API_ERROR: 241027,
	GET_LEX_BOT_V2_SLOT_TYPES_API_ERROR: 241028,
	GET_PINPOINT_APPLICATIONS_ERROR: 241029,
	SEND_OUTBOUND_SMS_NOTIFICATION_ERROR: 241030,
	GET_ALL_ROLES_API_ERROR: 241031,
	UPDATE_ROLE_API_ERROR: 241032,
	DELETE_ROLE_API_ERROR: 241033,
	GET_VOICEMAIL_AUDIO_ERROR: 241034,
	GET_EMAILS_ERROR: 241035,
	SEND_EMAIL_ERROR: 241036,
	END_EMAIL_INTERACTION_ERROR: 241037,
	GET_EMAIL_DOMAINS_ERROR: 241038,
	NO_INQUIRY_ID_ERROR: 241039,
	COPY_ERROR: 241040,
	COPY_FALLBACK_ERROR: 241041,
	CHIME_VIDEO_CREATE_ERROR: 241042,
	CHIME_VIDEO_DELETE_ERROR: 241043,
	CHIME_MEETING_END_ERROR: 241044,
	VIDEO_MEETING_END_AGENT_ERROR: 241045,
	START_TEAMS_CONVERSATION_ERROR: 241046,
	GET_TEAMS_CONVERSATION_STATUS_ERROR: 241047,
	SET_TEAMS_PRESENCE_ERROR: 241048,
	AZURE_GET_GROUPS_ERROR: 241049,
	AZURE_GET_GROUPS_USERS_ERROR: 241050,
	GET_EMAIL_ATTACHMENT_ERROR: 241051,
	GET_ATTACHMENT_UPLOAD_URL_ERROR: 241052,
	UPLOAD_EMAIL_ATTACHMENT_ERROR: 241053,
	GET_QUEUE_CALLBACKS_CONFIG_ERROR: 241054,
	UPDATE_QUEUE_CALLBACKS_CONFIG_ERROR: 241055,
	UPDATE_EMAIL_INTERACTION_ERROR: 241056,
};
